import _filter from "lodash/filter";
import _sortBy from "lodash/sortBy";
import _take from "lodash/take";
import _drop from "lodash/drop";
import { MediaType } from "shared-types";
import { MediaItem } from "pages/Profile/types";

export const sortMedia = (mediaList: MediaItem[]) => {
  const allVideos = _sortBy(
    _filter(mediaList, { mediaType: MediaType.Video }),
    "sortOrder"
  );
  const allAudios = _sortBy(
    _filter(mediaList, { mediaType: MediaType.Audio }),
    "sortOrder"
  );

  const headVideos = _take(allVideos, 3);
  const headAudios = _take(allAudios, 3);

  const tailVideos = _drop(allVideos, 3);
  const tailAudios = _drop(allAudios, 3);

  return [...headVideos, ...headAudios, ...tailVideos, ...tailAudios];
};
